import Highlighter from 'react-highlight-words';
import { CSSProperties, FC } from 'react';

import Text from '../Text';
import { PicklistItem, StandardPicklistItem } from '../Picklist';

type ItemProps = {
  item: PicklistItem;
  style?: CSSProperties;
  onClick?: (value: StandardPicklistItem) => void;
  search?: string;
};

const Item: FC<ItemProps> = ({ item, style, onClick, search }) => {
  if (!item.type) {
    return (
      <button
        aria-label={item.key.toString()}
        type="button"
        key={item.key}
        className="flex flex-col text-left w-full px-1.5 py-1 hover:bg-gray-100 cursor-pointer bg-white border-0 hover:bg-gray6"
        style={style}
        onClick={onClick ? () => onClick(item) : undefined}
      >
        <Text>
          <Highlighter
            searchWords={search ? [search] : []}
            autoEscape
            textToHighlight={item.text}
          />
        </Text>
        {item.secondaryText && (
          <Text variant="metadata-sm" className="text-gray2">
            <Highlighter
              searchWords={search ? [search] : []}
              autoEscape
              textToHighlight={item.secondaryText}
            />
          </Text>
        )}
      </button>
    );
  }
  if (item.type === 'header') {
    return (
      <div
        key={item.value}
        className="flex text-left w-full px-1.5 py-1 text-gray-500"
        style={style}
      >
        <Text weight="semibold" variant="metadata">
          {item.value}
        </Text>
      </div>
    );
  }

  if (item.type === 'divider') {
    return (
      <div key={item.key} style={style}>
        <hr />
      </div>
    );
  }

  return null;
};

export default Item;
